import cockpit from './versions/cockpit'
import legacy from './versions/legacy'

export default {
  '1.0.0': legacy,
  '1.5.0': cockpit,
  '1.5.1': cockpit,
  '1.5.2': cockpit,
  '1.5.3': cockpit,
  '1.5.4': cockpit
}
